<cx-searchbox
  [quickOrder]="true"
  [searchValueClear]="clearSearchValue"
  (selectedProductEvent)="onProductSelected($event)"
[config]="QUICKORDER_SEARCH_BOX_CONFIG"></cx-searchbox>

@if (quickOrderDetail) {
  <section class="quick-prod-details">
    @if (!productInfo.flu) {
      <section class="row unit-calc">
        <section class="price-details">
          <strong>{{ 'plp.yourPrice' | cxTranslate }}</strong>
          <section class="price-total">
            @if (
              productInfo?.price == undefined ||
              productInfo?.price?.value === undefined
              ) {
              <span
                >
                -
              </span>
            }
            @if (productInfo?.price && productInfo?.price?.value !== undefined) {
              <span
                >
                <span>{{ productInfo?.price?.value | localCurrency }}</span>
              </span>
            }
          </section>
        </section>
        @if (
          productInfo?.price == null ||
          productInfo?.price == undefined ||
          productInfo?.price?.value == 0.0
          ) {
          <section
            class="no-price"
            >
            <p>{{ 'plp.noPrice' | cxTranslate }}</p>
          </section>
        }
        @if (
          productInfo?.price != null &&
          productInfo?.price != undefined &&
          productInfo?.price?.value != undefined &&
          productInfo?.price?.value != 0.0 &&
          !productInfo?.discontinued && productInfo?.available
          ) {
          <section
            class="units"
            >
            <strong class="prodUnits">{{ 'plp.units' | cxTranslate }}</strong>
            <section class="unit-area">
              <span
                class="disabled"
                aria-hidden="true"
                id="{{ 'minusIcon' + productInfo.code + 'q' }}"
          (click)="
            performQuantityComputation(
              2,
              productInfo.code + 'q',
              productInfo.quantityPerUnit
            )
          ">
                <img
                  src="icons/less.svg"
                  id="{{ 'unitMinus' + productInfo.code + 'q' }}"
                  class="disabled-img"
                  alt="" />
                <img
                  src="icons/less-disable.svg"
                  id="{{ 'unitMinusDisable' + productInfo.code + 'q' }}"
                  alt="" />
              </span>
              <input
                type="number"
                class="prod-quantity text-center"
                value="1"
          (keyup)="
            performQuantityComputation(
              null,
              productInfo.code + 'q',
              productInfo.quantityPerUnit
            )
          "
                onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                id="{{ 'prodQuantity' + productInfo.code + 'q' }}"
                maxlength="4" />
              <span
                class=""
                aria-hidden="true"
                id="{{ 'plusIcon' + productInfo.code + 'q' }}"
          (click)="
            performQuantityComputation(
              1,
              productInfo.code + 'q',
              productInfo.quantityPerUnit
            )
          ">
                <img
                  src="icons/more.svg"
                  id="{{ 'unitPlus' + productInfo.code + 'q' }}"
                  alt="" />
                <img
                  src="icons/more-disable.svg"
                  id="{{ 'unitPlusDisable' + productInfo.code + 'q' }}"
                  class="disabled-img"
                  alt="" />
              </span>
            </section>
            <section
              class="dosessection"
              id="{{ 'noOfDoses' + productInfo.code + 'q' }}">
              {{ productInfo.quantityPerUnit }} {{ 'plp.doses' | cxTranslate }}
            </section>
          </section>
        }
        @if (
          productInfo?.price != null &&
          productInfo?.price != undefined &&
          productInfo?.price?.value !== undefined &&
          productInfo?.price?.value !== 0.0 &&
          !productInfo?.discontinued && productInfo?.available
          ) {
          <button
            type="button"
            class="btn blue-button quickorder-button"
            [ngbPopover]="popTitleSuccess"
            placement="bottom"
            triggers="manual"
            #p2="ngbPopover"
            popoverClass="savesuccess-msg"
            [closeDelay]="500"
            (click)="addToCart(productInfo?.code + 'q', productInfo?.code)">
            <ng-template #popTitleSuccess>
              <div class="cart-value-added">
                <img
                  src="icons/confirmation-positive-green.png"
                  class="positive-green-icon"
                  alt="suc" />
                <span class="confirmation-itemsadded">
                  {{ itemAddedQuantity }}
                  {{ 'addToCartItems.addEntrySuccess' | cxTranslate }}
                </span>
              </div>
            </ng-template>
            @if (buttonName === 'reserveNow') {
              <em
                class="fa fa-calendar"
              aria-hidden="true"></em>
            }
            {{ 'addToCartItems.' + buttonName | cxTranslate }}
          </button>
        }
        @if (
          productInfo?.price != null &&
          productInfo?.price != undefined &&
          productInfo?.price?.value != undefined &&
          productInfo?.price?.value != 0.0 &&
          !productInfo?.discontinued && productInfo?.available
          ) {
          <section
            >
            @if (productInfo.sapAllocation) {
              <section>
                <strong class="prod-allocation">
                  {{ 'plp.productAllocation' | cxTranslate }}
                </strong>
                <p class="allocation-p">{{ 'plp.allocationDetails' | cxTranslate }}</p>
              </section>
            }
          </section>
        }
      </section>
    }
    @if (productInfo?.discontinued || !productInfo?.available) {
      <section>
        @if (productInfo?.discontinued && productInfo?.available) {
          <section>
            <p class="product-discontinued-txt1">
              {{ 'plp.discontinued' | cxTranslate }}
            </p>
          </section>
        }
        @if (productInfo?.discontinued && !productInfo?.available) {
          <section>
            <p class="product-discontinued-txt1">
              {{ 'plp.discontinued' | cxTranslate }}
            </p>
          </section>
        }
        @if (!productInfo.discontinued && !productInfo?.available) {
          <section
            class="m0 left-align">
            @if (productInfo?.availabilityText) {
              <strong
                class="prod-allocation class-avail"
                >
                {{ productInfo?.availabilityText }}
              </strong>
            }
            @if (!productInfo?.availabilityText) {
              <strong
                class="prod-allocation class-avail"
                >
                {{ 'plp.noavailabilityText' | cxTranslate }}
              </strong>
            }
          </section>
        }
      </section>
    }
    @if (productInfo?.flu) {
      <section class="flu-section">
        <section>
          @if (
            productInfo.flu && productInfo.available && !productInfo.discontinued
            ) {
            <button
              type="button"
              class="btn blue-button m0-spacing"
              (click)="navToReservenow()">
              @if (buttonName === 'reserveNow') {
                <em
                  class="fa fa-calendar"
                aria-hidden="true"></em>
              }
              {{ 'plp.reserve' | cxTranslate }}
            </button>
          }
        </section>
      </section>
    }
  </section>
}
